import { format } from 'date-fns';
import removeIcon from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/trash.png'
import editIcon from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/DropdownIcons/changeTag.png'

import DeviceCard from './DeviceCard';
import { useDispatch } from 'react-redux';
import { deleteAjaxFromSite, deleteWebeyeIntegration, removeAibox, unlinkDahua, unlinkHikvision } from '../../../../Api Methods/Api';
import { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import Lottie from 'lottie-react';
import areYouSure from '../../../../assets/animations/areYouSure.json'
import { Button } from 'primereact/button';
import { useSelector } from 'react-redux';
import HikvisionEditForm, { EVENT_NAME_MAP } from '../Automations/VirutalSources/Hikvision/hikvisionEditForm';
import DahuaEditForm from '../Automations/VirutalSources/Dahua/dahuaEditForm';
import AiboxEditForm from '../Automations/VirutalSources/Aibox/aiboxEditForm';
import UseDisplayUserName from '../../../hooks/UseDisplayUserName';

const IntegrationCard = ({integration, pinObject, apiData, siteUUID, showSuccess, refreshDevices}) => {

  console.log(integration);

    const dispatch = useDispatch();
    const role = useSelector(state => state.auth.role);

    const integrationTitle = integration.integrationType
    const ID = integration.extraField1

    const parsed = integration?.extraField2
        ? JSON.parse(integration.extraField2)
        : [];

    console.log(parsed);

    const zoneName = ` ${parsed?.[0]?.zoneName || ""}`;
    let isControllingType = parsed?.[0]?.controlLevel || ""
    if (isControllingType == "output_relay") isControllingType = "Relays"
        if (isControllingType == "channel") isControllingType = "Channels"
    const isControlling = parsed?.[0]?.ruleUUIDs || ""

    const events = (() => {
        if (integration.integrationType === "HIKVISION") {
            return [...new Set(parsed.map(p => p?.eventType).filter(Boolean))]
                .map(eventType => EVENT_NAME_MAP[eventType] ?? eventType)
                .join(", ");
        }
        if (integration.integrationType === "DAHUA" && integration.extraField2) {
            try {
                const parsedEvents = JSON.parse(integration.extraField2);
                const list = Array.isArray(parsedEvents) ? parsedEvents : (parsedEvents?.eventsToHandle ?? []);
                return [...new Set(list)].join(", ");
            } catch {
                return "";
            }
        }
        return "";
    })();

    const channels = (() => {
        if (integration.integrationType === "HIKVISION" && integration.extraField3) {
            try {
                return JSON.parse(integration.extraField3).join(", ");
            } catch {
                return "";
            }
        }
        if (integration.integrationType === "DAHUA" && integration.extraField3) {
            try {
                const parsedChannels = JSON.parse(integration.extraField3);
                const list = Array.isArray(parsedChannels) ? parsedChannels : (parsedChannels?.channelIds ?? []);
                return [...new Set(list.map(channel => channel?.channel ?? channel))].join(", ");
            } catch {
                return "";
            }
        }
        return "";
    })();

    const addedBy = integration.addedBy
    const dateAdded = integration.created_at

    const [showConfirm, setShowConfirm] = useState(false)
    const [showEdit, setShowEdit] = useState(false)
  

    const unlink = async () => {
      switch (integration.integrationType) {
        case "HIKVISION" : {
          const responseData = await unlinkHikvision(apiData, siteUUID, pinObject.Pin, dispatch)
          if (responseData.success) {
            setShowConfirm(false)
            showSuccess(true)
            refreshDevices()
          }
        }
        break;
        case "DAHUA": {
          const responseData = await unlinkDahua(apiData, siteUUID, pinObject.Pin, dispatch)
          if (responseData.success) {
            setShowConfirm(false)
            showSuccess(true)
            refreshDevices()
          }
        }
        break;
        case "AJAX": {
          const responseData = await deleteAjaxFromSite(apiData, siteUUID, ID, dispatch)
          if (responseData.data.success){
            setShowConfirm(false)
            showSuccess(true)
            refreshDevices()
          }
        }
        break;
        case "AIBOX": {
          const responseData = await removeAibox(apiData, siteUUID, pinObject.Pin, dispatch)
          if (responseData) {
            setShowConfirm(false)
            showSuccess(true)
            refreshDevices()
          }
        }
        case "WEBEYE": {
          let body = {
            "uuid": siteUUID,
            "pin": pinObject.Pin
          }
          const responseData = await deleteWebeyeIntegration(apiData,body, dispatch)
          if (responseData) {
            setShowConfirm(false)
            showSuccess(true)
            refreshDevices()
          }
        }
        break;
      }

    }

    return (
      <>

        <Dialog
            header="Are you sure?"
            visible={showConfirm}
            style={{ width: "40vw" }}
            onHide={() => setShowConfirm(false)}
        >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>

                <Lottie
                    animationData={areYouSure}
                    loop={false}
                    style={{ width: 150, height: 150, margin: "0px" }}
                />
                <br />
                <h3 style={{ color: "#6e6e6eff" }}>{`Are you sure you want to unlink this ${integration.integrationType}?`}</h3>
                <br />
                <Button label="No cancel" icon="pi pi-times" severity="secondary" onClick={() => setShowConfirm(false)} />
                <br />
                <Button label="Yes, unlink" icon="pi pi-check" severity="danger" onClick={() => unlink()} />

            </div>
        </Dialog>
      
        {integration.integrationType === "HIKVISION" && (
            <Dialog
                header="Edit"
                visible={showEdit}
                style={{ width: "40vw" }}
                onHide={() => setShowEdit(false)}
            >
                <HikvisionEditForm
                    integration={integration}
                    apiData={apiData}
                    siteUUID={siteUUID}
                    pin={pinObject.Pin}
                    onClose={() => setShowEdit(false)}
                    refreshDevices={refreshDevices}
                />
            </Dialog>
        )}

        {integration.integrationType === "DAHUA" && (
            <Dialog
                header="Edit"
                visible={showEdit}
                style={{ width: "40vw" }}
                onHide={() => setShowEdit(false)}
            >
                <DahuaEditForm
                    integration={integration}
                    apiData={apiData}
                    siteUUID={siteUUID}
                    pin={pinObject.Pin}
                    onClose={() => setShowEdit(false)}
                    refreshDevices={refreshDevices}
                />
            </Dialog>
        )}

        {integration.integrationType === "AIBOX" && (
            <Dialog
                header="Edit"
                visible={showEdit}
                style={{ width: "40vw" }}
                onHide={() => setShowEdit(false)}
            >
                <AiboxEditForm
                    integration={integration}
                    apiData={apiData}
                    siteUUID={siteUUID}
                    pin={pinObject.Pin}
                    onClose={() => setShowEdit(false)}
                    refreshDevices={refreshDevices}
                />
            </Dialog>
        )}


        <DeviceCard
          header={`${integrationTitle} ${zoneName}`}
          subHeader={
            isControllingType !== "rule"
              ? `${isControllingType} ${isControlling}`
              : "Rules"
          }
          meta={[
            ID,
            ...(events ? [`Events: ${events}`] : []),
            ...(channels ? [`Channels: ${channels}`] : []),
          ]}
          rightContent={
            <>
              <h3 style={{color:"var(--Primary-Color)"}}>{pinObject.pinName}</h3>
              <div style={{gap:"10px"}}>
                {(role === "admin" || role === "TechSupport") && <img src={removeIcon} style={{width:"25px", cursor:"pointer", marginRight:"5px"}} onClick={() => setShowConfirm(true)} />}
                {(role === "admin" || role === "TechSupport") && ["HIKVISION", "DAHUA", "AIBOX"].includes(integration.integrationType) && <img src={editIcon} style={{width:"25px", cursor:"pointer"}} onClick={() => setShowEdit(true)} />}
              </div>
              
            </>
          }
          footer={
            integration.addedBy &&
            `Added by ${UseDisplayUserName(addedBy.fullName)} on ${format(
              new Date(dateAdded),
              "MMM do, yyyy"
            )}`
          }
        />
      </>
      );
}

export default IntegrationCard;